import axios from 'axios';
import { PecasApi } from '../../../api';

async function DeletarPeca(id) {
  try {
    const response = await axios.delete(`${PecasApi}/${id}`);
    return response.data.mensagem;
  } catch (error) {
    console.error('Error fetching data:', error); // Log the error for debugging
    return []; // Return an empty array in case of error
  }
}

export default DeletarPeca;